// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"location-item_infoContainer__2t5-w","icon":"location-item_icon__19WkV","column":"location-item_column__31MCh"};